import React, { Fragment } from 'react';
import { createTooltipIcon } from '../utils/createTooltipIcon';

export const Eggs = createTooltipIcon(
  () => (
    <Fragment>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42.425 55.5791C38.3616 59.731 32.6168 62.0151 26.2496 62.0151C19.8824 62.0151 14.1376 59.731 10.0742 55.5791C5.68184 51.0923 3.35854 44.6591 3.35854 36.9743C3.35854 28.8753 5.87744 20.4436 10.2719 13.8397C14.7686 7.08842 20.4424 3.36803 26.2496 3.36803C32.0568 3.36803 37.7314 7.08842 42.228 13.8426C46.6225 20.4465 49.1414 28.8775 49.1414 36.9779C49.1414 44.662 46.8166 51.0959 42.425 55.5791ZM45.02 11.9726C42.6004 8.33436 39.8156 5.44872 36.7454 3.38838C33.3919 1.1406 29.8602 0 26.2496 0C22.639 0 19.1066 1.1406 15.7538 3.39128C12.6836 5.44872 9.90174 8.33799 7.47919 11.9756C2.72754 19.1185 0 28.2338 0 36.9772C0 45.5615 2.65437 52.8126 7.67769 57.9402C12.3808 62.7387 18.9747 65.3839 26.2503 65.3839C33.5259 65.3839 40.1199 62.7387 44.8201 57.9402C49.8427 52.8119 52.4978 45.5615 52.4978 36.9772C52.4978 28.2309 49.7731 19.1156 45.0215 11.9726H45.02Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.1734 5.76851C21.1315 5.76851 15.902 9.33542 11.8265 15.5561C11.3012 16.3587 11.5147 17.4396 12.3001 17.9744C12.5912 18.1745 12.923 18.2685 13.2495 18.2685C13.8037 18.2685 14.346 17.9947 14.6747 17.4922C18.1037 12.2562 22.2944 9.25644 26.1734 9.25644C27.1191 9.25644 27.8845 8.47491 27.8845 7.51435C27.8845 6.55079 27.1191 5.76851 26.1734 5.76851Z"
      />
    </Fragment>
  ),
  '0 0 53 66'
);
